import { string } from 'yup';
import { RegisterFormValidationModel } from '@/src/lib/validation/models/register-form-validation.model';
import { getMaxLengthMessage, getZipCodeMessage } from '@/src/lib/dictionary/utils';
import { ValidationConfigCZ } from '@/src/lib/validation/validation.config';

export class RegisterFormValidationModelCZ extends RegisterFormValidationModel {
  public get street() {
    const fieldName = this.DICT.userProfile.userData.street;
    const maxLength = 100;
    return string()
      .required(this.REQUIRED_MESSAGE)
      .max(maxLength, getMaxLengthMessage(fieldName, maxLength, this.DICT))
      .trim();
  }

  public get houseNumber() {
    const fieldName = this.DICT.userProfile.userData.houseNumber;
    const maxLength = 50;
    return string()
      .required(this.REQUIRED_MESSAGE)
      .max(maxLength, getMaxLengthMessage(fieldName, maxLength, this.DICT))
      .trim();
  }

  public get company() {
    const fieldName = this.DICT.userProfile.userData.companyName;
    const maxLength = 300;
    return string()
      .required(this.REQUIRED_MESSAGE)
      .trim()
      .max(maxLength, getMaxLengthMessage(fieldName, maxLength, this.DICT));
  }

  public get zipCode() {
    const fieldName = this.DICT.userProfile.userData.postcode;
    const maxLength = ValidationConfigCZ.ZIP_MAX_LENGTH;

    return string()
      .required(this.REQUIRED_MESSAGE)
      .trim()
      .matches(ValidationConfigCZ.ZIP_REGEX, getZipCodeMessage(this.DICT, this.TENANT_CONFIG.zipCodeExample.default))
      .length(ValidationConfigCZ.ZIP_MAX_LENGTH, getMaxLengthMessage(fieldName, maxLength, this.DICT));
  }
}
